import React, { useEffect, useState } from 'react';
import { Default as Alert } from '@gjensidige/core-alerts';
import { Label, Text } from '@gjensidige/core-typography';
import { kr } from '@gjensidige/gpf-js-utils/es6/text/formatting';
import { useFetch } from '@gjensidige/gpf-react-components';
import { useParams } from 'react-router-dom';
import { text } from '../../../utils/text';
import { getAvtaleGiroUrl, getSignResult } from '../../../utils/api';
import { Layout } from '../../common/Layout/Layout';
import { Card, CardHeader } from '../../common/Card/Card';
import { CriticalButton } from '@gjensidige/core-buttons';
import utils from '@gjensidige/core-utilities-css';
import { Spacer } from '../../common/Spacer/Spacer';
import { SpinnerPage } from '../../common/SpinnerPage/SpinnerPage';
import { KidAccountCopy } from '../../common/KidAccountCopy/KidAccountCopy';
import { Action } from '../../../utils/types';
import { useGlobalContext } from '../../../context/GlobalContext';
export const StartSavingPage = () => {
    const { requestId } = useParams();
    const [{ signResult }, dispatch] = useGlobalContext();
    const [isFetchingSignResult, setIsFetchingSignResult] = useState(false);
    useEffect(() => {
        if (!signResult) {
            setIsFetchingSignResult(true);
            getSignResult(requestId).then((result) => {
                if (result.isOk()) {
                    dispatch({
                        type: Action.UPDATE_SIGN_RESULT,
                        signResult: result.value,
                    });
                    setIsFetchingSignResult(false);
                }
            });
        }
    }, [dispatch, signResult, requestId]);
    const [isFetchingAvtalegiroUrl, avtalegiroUrl, error] = useFetch({
        promise: () => getAvtaleGiroUrl(requestId),
        deps: [requestId],
    });
    if (isFetchingSignResult || isFetchingAvtalegiroUrl) {
        return React.createElement(SpinnerPage, null);
    }
    if (error) {
        return React.createElement(Alert, { alertType: "error", title: text.COMMON.ALERT.TITLE.no, text: text.COMMON.ALERT.TEXT.no });
    }
    return (React.createElement(Layout, { title: text.LAYOUT.SIGNED_AGREEMENT.TITLE.no },
        React.createElement(Card, null,
            (signResult === null || signResult === void 0 ? void 0 : signResult.annuity) != undefined && signResult.annuity > 0 && (React.createElement("div", null,
                React.createElement(CardHeader, { title: text.START_SAVING_PAGE.MONTHLY.TITLE.no, subtitle: text.START_SAVING_PAGE.MONTHLY.SUBTITLE.no }),
                React.createElement(Spacer, null,
                    React.createElement("div", null,
                        React.createElement(Label, { className: utils['font-weight-bold'] }, text.START_SAVING_PAGE.ANNUITY_HEADER.no),
                        React.createElement(Text, null, kr(signResult === null || signResult === void 0 ? void 0 : signResult.annuity))),
                    React.createElement(CriticalButton, { className: utils['mb-2'], size: 'md', href: `${avtalegiroUrl ? avtalegiroUrl.avtalegiroUrl : ''}` }, text.START_SAVING_PAGE.CREATE_AVTALEGIRO.no)))),
            React.createElement("div", null,
                React.createElement(CardHeader, { title: text.START_SAVING_PAGE.OTP.TITLE.no, subtitle: text.START_SAVING_PAGE.OTP.SUBTITLE.no }),
                React.createElement(KidAccountCopy, { kid: signResult === null || signResult === void 0 ? void 0 : signResult.kid, accountNumber: signResult === null || signResult === void 0 ? void 0 : signResult.accountNumber }),
                React.createElement(Text, null, text.START_SAVING_PAGE.KID_AND_ACCOUNT_NUMBER_INFO.no)))));
};
